import React from 'react';
import PropTypes from 'prop-types';
import noop from 'utils/noop';
import Dropzone from 'dropzone';
import DropzonePreviewTemplate from 'components/DropzonePreviewTemplate';

const FILESIZE_BASE = 1000;

export default {
  propTypes: {
    options: PropTypes.array,
    onDropzoneInit: PropTypes.func,
    onSourceChanged: PropTypes.func,
    onFileAdded: PropTypes.func,
    onFileRemoved: PropTypes.func,
    onSuggestedFilename: PropTypes.func,
    onSuccess: PropTypes.func,
    onFilesizeTooLarge: PropTypes.func,
  },

  getDefaultProps() {
    return {
      maxFiles: 1,
      maxFilesize: 20,
      thumbnailWidth: 500,
      onDropzoneInit: noop,
      onSourceChanged: noop,
      onFileAdded: noop,
      onFileRemoved: noop,
      onSuggestedFilename: noop,
      onSuccess: noop,
      onFilesizeTooLarge: noop,
    };
  },

  handleDropzoneInit(dropzoneInstance) {
    this.setState({
      dropzone: dropzoneInstance,
    }, () => {
      this.props.onDropzoneInit(dropzoneInstance);
    });
  },

  handleAddedFile(file) {
    const fileName = file.name;
    const slugify = (str) => {
      return fileName.toLowerCase().substr(0, fileName.indexOf('.')).replace(/[^a-z\-]/, '');
    };

    this.props.onFileAdded(fileName);
    this.props.onSuggestedFilename(slugify(fileName));
  },

  handleDrop(file) {
    this.state.dropzone.removeAllFiles();
  },

  handleRemovedFile(file) {
    this.props.onFileRemoved(file.name);
  },

  handleProcessing() {
    const progressElement = this.getProgressNode();

    if (progressElement) {
      progressElement.style.display = 'block';
    }
  },

  handleUploadProgress(_file, percentage) {
    this.getProgressBarNode().value = `${percentage}`;
  },

  handleSuccess(file, response) {
    const progressElement = this.getProgressNode();

    if (progressElement) {
      progressElement.style.display = 'none';
    }

    this.props.onSuccess(file);
  },

  handleError(file, xhr) {
    const maximumSize = this.props.maxFilesize * FILESIZE_BASE * FILESIZE_BASE;
    const progressElement = this.getProgressNode();

    file.previewElement.classList.remove('dz-processing');
    file.status = Dropzone.QUEUED;
    file.processing = false;
    file.upload.progress = 0;
    file.upload.bytesSent = 0;

    for (const errorMessage of file.previewElement.querySelectorAll("[data-dz-errormessage]")) {
      errorMessage.textContent = '';
    }

    if (progressElement) {
      progressElement.style.display = 'none';
    }

    if (file.size > maximumSize) {
      this.state.dropzone.removeFile(file);
      this.props.onFilesizeTooLarge(file.size, maximumSize);
    }
  },

  handleMaxFilesExceeded(file) {
    this.state.dropzone.removeFile(file);
  },

  getProgressNode() {
    return document.querySelector('.drop-progress');
  },

  getProgressBarNode() {
    return document.querySelector('.drop-progress .progress');
  },

  dropzoneProps(extraEventHandlers = {}, extraDropzoneConfig = {}) {
    const eventHandlers = Object.assign({}, {
      init: this.handleDropzoneInit,
      drop: () => {},
      addedfile: this.handleAddedFile,
      drop: this.handleDrop,
      removedfile: this.handleRemovedFile,
      processing: this.handleProcessing,
      uploadprogress: this.handleUploadProgress,
      success: this.handleSuccess,
      error: this.handleError,
      maxfilesexceeded: this.handleMaxFilesExceeded,
    }, extraEventHandlers);

    const test = 'asdf';

    const djsConfig = Object.assign({}, {
      url: '-deferred-',
      autoProcessQueue: false,
      maxFiles: this.props.maxFiles,
      maxFilesize: this.props.maxFilesize,
      filesizeBase: FILESIZE_BASE,
      thumbnailWidth: this.props.thumbnailWidth,
      thumbnailHeight: null,
      previewTemplate: DropzonePreviewTemplate,
    }, extraDropzoneConfig);

    return {eventHandlers, djsConfig};
  },
};



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/mixins/DropzoneComponentMixin.js